import { useParams } from "react-router-dom";
import { useProspect, useReviewMutation } from "@/hooks/useProspect";
import { LeadInfoPanel } from "@/components/LeadInfoPanel";
import { EmailReviewPanel } from "@/components/EmailReviewPanel";
import { buildApprovePayload, buildRejectPayload } from "@/lib/review";
import { PROSPECT_STATUS_LABELS, PROSPECT_STATUS_COLORS } from "@/lib/types";

export function ProspectDetail() {
  const { id } = useParams<{ id: string }>();
  const { data: prospect, isLoading, error } = useProspect(id);
  const mutation = useReviewMutation(id ?? "");

  if (isLoading) return <div className="p-8 text-sm text-neutral-500">Chargement…</div>;
  if (error)
    return (
      <div className="p-8 text-sm text-red-600">Erreur : {String((error as Error).message)}</div>
    );
  if (!prospect) return <div className="p-8 text-sm text-neutral-500">Lead introuvable.</div>;

  const fullName =
    [prospect.first_name, prospect.last_name].filter(Boolean).join(" ") || prospect.email;

  return (
    <div className="min-h-screen bg-neutral-50">
      <div className="mx-auto max-w-6xl p-6">
        <div className="mb-5 flex items-start justify-between rounded-lg border border-neutral-200 bg-white px-5 py-4">
          <div>
            <p className="text-xs text-neutral-400">Fermer l'onglet pour revenir à la liste</p>
            <h1 className="text-xl font-bold text-aurora-navy">{fullName}</h1>
            <p className="text-sm text-neutral-600">
              {[prospect.job_title, prospect.company_name].filter(Boolean).join(" · ")}
            </p>
          </div>
          <span
            className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${PROSPECT_STATUS_COLORS[prospect.status]}`}
          >
            {PROSPECT_STATUS_LABELS[prospect.status]}
          </span>
        </div>

        {mutation.isError && (
          <div className="mb-4 rounded-md bg-red-50 px-4 py-2 text-sm text-red-700">
            Échec de l'enregistrement : {String((mutation.error as Error).message)}
          </div>
        )}

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-[1.15fr_1fr]">
          <LeadInfoPanel prospect={prospect} />
          <EmailReviewPanel
            prospect={prospect}
            isSaving={mutation.isPending}
            onApprove={(args) => mutation.mutate(buildApprovePayload(args))}
            onReject={(note) => mutation.mutate(buildRejectPayload(note))}
          />
        </div>
      </div>
    </div>
  );
}
